import React, { Component } from "react";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";

class PrivacyPolicy extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <div className="privacy-sec">
        <Helmet>
          <title>Privacy Policy | TicTacLearn</title>
        </Helmet>
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="privacy-updated">Last updated: 16 July 2026</p>

          <p>
            TicTacLearn is an initiative of Central Square Foundation ("CSF",
            "we", "us") that makes free, high-quality math and science learning
            content available to students and teachers. This policy explains
            what information we collect when you use{" "}
            <a href="https://tictaclearn.org">tictaclearn.org</a> (the
            "Website") and how we use it.
          </p>

          <h2>Information we collect</h2>
          <ul>
            <li>
              <strong>Usage data.</strong> We use Google Analytics to
              understand how visitors use the Website — for example, pages
              visited, approximate location (city level), device and browser
              type, and how you arrived at the Website. This data is collected
              through cookies and similar technologies and is aggregated; it
              does not directly identify you.
            </li>
            <li>
              <strong>Information you give us.</strong> If you contact us
              through the form on our homepage or by email, we receive the
              details you share with us (such as your name, email address, and
              message).
            </li>
            <li>
              <strong>Preferences stored on your device.</strong> The Website
              stores your selections (such as your chosen language, grade, or
              recent search) in your browser's local storage so the Website
              works smoothly. This information stays on your device and you can
              clear it at any time through your browser settings.
            </li>
          </ul>

          <h2>How we use information</h2>
          <ul>
            <li>To operate, maintain, and improve the Website and our content;</li>
            <li>To respond to your enquiries and messages;</li>
            <li>
              To understand overall usage patterns so we can make our learning
              content more useful.
            </li>
          </ul>

          <h2>What we do not do</h2>
          <ul>
            <li>We do not sell your personal information;</li>
            <li>We do not use your information for advertising;</li>
            <li>
              We do not require you to create an account or submit personal
              information to access our learning content.
            </li>
          </ul>

          <h2>Cookies and analytics</h2>
          <p>
            Google Analytics sets cookies to help us measure Website usage. You
            can block or delete cookies through your browser settings, or opt
            out of Google Analytics entirely using the{" "}
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Analytics opt-out browser add-on
            </a>
            . The Website remains fully usable without cookies.
          </p>

          <h2>Third-party services and links</h2>
          <p>
            Our videos are hosted on YouTube, and the Website links to external
            platforms such as YouTube and DIKSHA. When you play an embedded
            video or follow a link to another site, that service's own privacy
            policy applies. We encourage you to review the privacy policies of{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google/YouTube
            </a>{" "}
            and any other site you visit.
          </p>

          <h2>Children's privacy</h2>
          <p>
            Our content is designed for students, but the Website does not ask
            children for any personal information and does not knowingly
            collect personal information from children. If you believe a child
            has shared personal information with us, please contact us and we
            will delete it.
          </p>

          <h2>Data sharing and security</h2>
          <p>
            We share information only with the service providers that help us
            run the Website (such as our hosting and analytics providers), and
            only to the extent needed for them to provide their services. We
            take reasonable technical and organisational measures to protect
            the information we hold, including serving the Website over HTTPS.
          </p>

          <h2>Your choices and rights</h2>
          <p>
            You may write to us at any time to ask what information we hold
            about you, or to request correction or deletion of information you
            have shared with us. We handle personal information in accordance
            with applicable Indian law, including the Digital Personal Data
            Protection Act, 2023.
          </p>

          <h2>Changes to this policy</h2>
          <p>
            We may update this policy from time to time. Any changes will be
            posted on this page with an updated "Last updated" date.
          </p>

          <h2>Contact us</h2>
          <p>
            For any questions about this policy or your data, contact us at{" "}
            <a href="mailto:tictaclearn@centralsquarefoundation.org">
              tictaclearn@centralsquarefoundation.org
            </a>
            .
          </p>
          <p>
            Central Square Foundation
            <br />
            New Delhi, India
          </p>
        </div>
      </div>
    );
  }
}

export default PrivacyPolicy;
